import React from "react";

import "./index.scss";

const CancelIcon = props => {
  const iconType = props.type || "default";
  const iconWH = props.type == "remove" ? "20" : "32";
  return (
    <svg
      id="Cross"
      xmlns="http://www.w3.org/2000/svg"
      width={iconWH}
      height={iconWH}
      viewBox="0 0 32 32"
      className="parentCross"
      disabled={props.disabled}
    >
      <g id="Cross-2" data-name="Cross" transform="translate(0, -1)">
        <g id="Group_8949" data-name="Group 8949">
          <rect id="Margin" className="cross1" width="32" height="32" />
          <path
            id="Path_8818"
            data-name="Path 8818"
            className={`${iconType} cross2`}
            d="M22,11.333,20.667,10,16,14.667,11.333,10,10,11.333,14.667,16,10,20.667,11.333,22,16,17.333,20.667,22,22,20.667,17.333,16Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default CancelIcon;
